import React, { useCallback } from 'react';
import styled from 'styled-components';
import {
    CaretDownOutlined,
    ColorMode,
    useBreakpoint,
    Button,
    Popover,
} from '@landr/maestro';
import { BpmControl } from 'components/Creator/BpmControl';
import { BpmControlPopoverProps } from './BpmControlPopover.types';

const HideAtCustomBreakpoint = styled.div`
    margin-left: 0.25em;

    @media (max-width: 350px) {
        display: none;
    } /* @maestro-no-token */
`;

export const BpmControlPopover = ({
    bpm,
    onApply,
    isDisabled = false,
}: BpmControlPopoverProps): JSX.Element => {
    const handleApply = useCallback(
        (newBpm: number): void => {
            onApply(newBpm);
        },
        [onApply],
    );

    const isMobile = useBreakpoint('md');
    const iconRight = isMobile ? undefined : CaretDownOutlined;

    return (
        <Popover placement="top-end">
            {({ close }): JSX.Element => (
                <>
                    <Popover.Trigger>
                        {/*
                        Note: Tooltip can't handle popover onClick, leave commented for now
                        <Tooltip
                            position="top"
                            content={i18n._(t`Choose the BPM of your session`)}
                        > */}
                        <Button
                            variant="secondary"
                            isRounded
                            size="sm"
                            iconRight={iconRight}
                            isDisabled={isDisabled}
                        >
                            {bpm}
                            <HideAtCustomBreakpoint>bpm</HideAtCustomBreakpoint>
                        </Button>
                        {/* </Tooltip> */}
                    </Popover.Trigger>
                    <ColorMode mode="dark">
                        <Popover.Content py={0} px={0}>
                            <BpmControl
                                onApply={handleApply}
                                initialBpm={bpm}
                                onClick={close}
                            />
                        </Popover.Content>
                    </ColorMode>
                </>
            )}
        </Popover>
    );
};
